// extracted by mini-css-extract-plugin
module.exports = {"sideTabMenu":"style_sideTabMenu__2s1XG","addedMarginTab":"style_addedMarginTab__xl-Lf"};